import { v4 } from 'uuid'
import { message, notification } from 'antd'

const generateId = () => v4().split('-').join('')

//mergeBlocksIntoDoc
const messageKey = 'updatable'

const uploadDoc = (doc, blocks, baseUrl) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify(doc)

    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };
    let error;
    message.loading({ content: 'Creating New Page', key: messageKey })
    fetch(`${baseUrl}/addPages/`, requestOptions)
        .then(response => {
            let res = response.json()
            if (response.status === 500) {
                error = true
            }
            return res
        })
        .then(result => {

            if (error) {
                message.error({ content: 'Error while creating new page', key: messageKey })
            }
        })
        .catch(error => {
            console.log('error', error)
        });

    requestOptions.body = JSON.stringify({ blocks: blocks })
    fetch(`${baseUrl}/addBlocks/`, requestOptions)
        .then(response => {
            let res = response.json()
            if (response.status === 500) {
                error = true
            }
            return res
        })
        .then(result => {
            if (error) {
                message.error({ content: 'Error while creating new page', key: messageKey })

            }
        })
        .catch(error => {
            console.log('error', error)
        });
    if (!error) {
        message.success({ content: 'Successfully Created New Page', key: messageKey })
    }
}
export const deletePage = async (id, baseUrl) => {
    var requestOptions = {
        method: 'GET',
        redirect: 'follow'
    };
    let status
    return fetch(`${baseUrl}/delete/page/${id}`, requestOptions)
        .then(response => {
            status = response.ok
            if (response.ok) {
                message.success({ content: 'Page Deleted Successfully', key: messageKey })
            }
            response.json()
        })
        .then(result => status)
        .catch(error => console.log('error', error));
}
export const changePageTitle = async (id, newTitle, baseUrl) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({ "title": newTitle });

    var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    fetch(`${baseUrl}/page/${id}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            message.success({ content: 'Changed Page Title', key: message })
        })
        .catch(error => console.log('error', error));
}
export const generateNewPage = async (userProps, baseUrl) => {
    let docId = generateId()
    let docs = {
        type: 'docs',
        id: docId,
        userId: userProps.userId,
        children: [
            {
                type: 'paragraph',
                id: generateId(),
                attrs: {},
                docsId: [docId],
                children: [{ text: '' }]

            }
        ],
        title: `new-page-${userProps.userId}`
    }
    let newPage = extractBlocksFromDoc(docs, userProps)
    uploadDoc(newPage.docsCollection, newPage.blockCollection, baseUrl)
    return { allPages: [newPage.docsCollection], page: (async () => docs)() }
}
export const getAllBlocksOfPage = (page, baseUrl) => {
    let blocks;
    let docs;
    var requestOptions = {
        method: 'GET',
        redirect: 'follow'
    };

    return fetch(`${baseUrl}/blocks/${page._id}`, requestOptions)
        .then(response => response.json())
        .then(result => {

            blocks = result.blocks
            let newObj = {}
            blocks = Array.from(blocks).map((child) => {
                newObj[child._id] = child
            })
            blocks = newObj
            docs = { ...page }
            const MergeBlock = (block) => {
                if (block?.hasOwnProperty('text')) {
                    return block
                }
                let element;
                if (blocks[block]) {
                    element = { ...blocks[block] }
                } else {
                    element = {
                        ...{ _id: generateId(), type: "error-block", attrs: {}, docsId: [docs._id], children: [{ text: "This block is deleted,Remove this placeholder" }] }
                    }
                }
                let children = Array.from(element.children).map(MergeBlock).flat()
                element.children = children
                element.id = element._id
                delete element._id
                return element
            }
            let pageChildren = Array.from(page.children).map(MergeBlock)

            docs.children = pageChildren
            docs.id = docs._id
            delete docs._id
            return docs

        })
        .catch(error => {
            console.log('error', error)
            message.error('Error occurred while fetching Data')

        });


}
export const mergeBlocksIntoDoc = async (userProps, baseUrl) => {

    const getAllPages = () => {
        let allPages;
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        return fetch(`${baseUrl}/pages/${userProps.userId}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                allPages = result.pages
                if (allPages.length > 0) {
                    let id = localStorage.getItem('seletedPageId')
                    let index = 0;
                    if (id) {
                        index = allPages.findIndex((val) => val._id === id)
                    }
                    if (index === -1) {
                        index = 0
                    }
                    let page = allPages[index]
                    return { allPages, page: getAllBlocksOfPage(page, baseUrl) }
                } else {
                    message.error({ content: 'No pages for user exists', key: messageKey })
                    return generateNewPage(userProps, baseUrl)
                }

            })
            .catch(error => {
                console.log('error', error)
                message.error('Error occurred while fetching All Pages')
            });

    }


    return await getAllPages()
}

export const extractBlocksFromDoc = (element, userProps) => {
    let blockCollection = []
    let docsCollection;
    let currentDocId;
    if (element.type === 'docs') {
        currentDocId = element.id
    } else {
        console.log('Please Enter Valid Doc')
        return []
    }

    const extractBlocks = (elementJson) => {

        if (elementJson?.hasOwnProperty('text')) {
            return elementJson
        }
        let children = Array.from(elementJson.children).map(extractBlocks).flat()

        if (elementJson.type === 'docs') {
            docsCollection = { ...elementJson }
            docsCollection.children = children
            docsCollection.userId = userProps.userId
            return
        }
        if (elementJson.type) {
            let block = { ...elementJson }
            if (block?.hasOwnProperty('docsId')) {
                if (!block.docsId.includes(currentDocId)) {
                    block.docsId = [...block.docsId, currentDocId]
                }
            } else {
                block.docsId = [currentDocId]
            }
            block.children = children
            if (elementJson.id) {
                blockCollection.push(block)
                return elementJson.id
            } else {
                console.log('Doesnt have id', elementJson.type)
                block.id = generateId()
                blockCollection.push(block)
                return block.id
            }
        }

    }
    extractBlocks(element)
    return { docsCollection, blockCollection }
}